import { FC } from 'react';
import { Content, isFilled } from '@prismicio/client';
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';

import { Bounded } from '@/components/common/Bounded';
import { Heading } from '@/components/common/Heading';

/**
 * Props for `ContentVisualCta`.
 */
export type ContentVisualCtaProps =
  SliceComponentProps<Content.ContentVisualCtaSlice>;

/**
 * Component for "ContentVisualCta" Slices.
 */
const ContentVisualCta: FC<ContentVisualCtaProps> = ({ slice }) => {
  return (
    <Bounded as="section" className="bg-dark-green text-white">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div className="flex flex-col gap-6">
          <PrismicRichText
            field={slice.primary.title}
            components={{
              heading1: ({ children }) => (
                <Heading as="h1" size="6xl">
                  {children}
                </Heading>
              ),
            }}
          />
          <div className="text-xl">
            <PrismicRichText field={slice.primary.description} />
          </div>
          {isFilled.link(slice.primary.cta) && (
            <PrismicNextLink
              field={slice.primary.cta}
              className="bg-gray-700 hover:bg-gray-800 transition-colors duration-200 ease-in-out py-4 px-8 rounded-full font-bold text-lg text-center"
            >
              {'text' in slice.primary.cta && slice.primary.cta.text
                ? slice.primary.cta.text
                : 'Meet Our Delivery Model'}
            </PrismicNextLink>
          )}
        </div>
        <div>
          <PrismicNextImage
            field={slice.primary.illustration}
            className="w-full h-auto"
          />
        </div>
      </div>
    </Bounded>
  );
};

export default ContentVisualCta;
